import { AgGridReact } from '@ag-grid-community/react';
import { Grid } from '@mui/material';
import { useAgGrid } from '@tassat/ag-grid';
import { TransactionStatusCode } from '@tassat/common-definitions';
import React from 'react';

import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-material.css';
import 'SharedComponents/agGrid/styles/agGridOverrides.css';

import { AG_GRID_SMALL_HEADER_HEIGHT } from 'Lib/constant';
import DateCellRender from 'SharedComponents/cellRenderComponent/datecellrender';
import { PledgeActionButtonCellRenderer } from 'SharedComponents/cellRenderComponent/pledgeActionButtonCellRenderer';
import { PledgeStatusCellRenderer } from 'SharedComponents/cellRenderComponent/pledgeStatusCellRenderer';
import { PledgeTransactionActionConversion } from 'SharedComponents/cellRenderComponent/pledgeTransactionActionCellRenderer';

import { PledgeTransactionsTableProps } from './types';
import { usePledgeTransactionColumnDefs } from './usePledgeTransactionColumnDefs';
import { PledgeTransactionRow } from '../../../modals/pledgeDetailsModal/pledgeContextWorkflow/pledgeContextWorkflowContext';

export const PledgeTransactionsTable = (props: PledgeTransactionsTableProps) => {
    const {
        pledgeTransactionList,
        asset,
        currentUser,
        currentRole
    } = props;
    const [ , onGridReady ] = useAgGrid();
    const columnDefs = usePledgeTransactionColumnDefs({
        currentRole,
        currentUser
    });

    return (
        <Grid
            item
            xs={9}
        >
            <div
                className='ag-theme-material'
                id='pledgeTransactionsGrid'
                style={{
                    height: '400px',
                    width: '100%'
                }}
            >
                <AgGridReact<PledgeTransactionRow>
                    animateRows={false}
                    columnDefs={columnDefs}
                    columnMenu='legacy'
                    components={{
                        dateCellRender: DateCellRender,
                        pledgeActionButtonCellRenderer: PledgeActionButtonCellRenderer,
                        pledgeTransactionActionRender: PledgeTransactionActionConversion,
                        pledgeStatusCellRenderer: PledgeStatusCellRenderer
                    }}
                    context={{ asset: asset }}
                    defaultColDef={{
                        resizable: true,
                        filter: false,
                        sortable: false
                    }}
                    enableCellTextSelection={true}
                    getRowId={({ data }) => data.PledgeTransactionRequestId}
                    headerHeight={AG_GRID_SMALL_HEADER_HEIGHT}
                    onGridReady={onGridReady}
                    rowClassRules={{ 'pendingRow': ({ data }) => data?.PledgeTransactionStatus === TransactionStatusCode.PENDING_APPROVAL }}
                    rowData={pledgeTransactionList}
                    suppressCellFocus={true}
                    suppressContextMenu={true}
                />
            </div>
        </Grid>
    );
};